<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content >
    <div class="main_div"  #captureContainer>
        <div class="item_list add_padding" *ngIf="creditDetails.length > 0">
            <div class="item_list_data add_margin_bottom" >
                <span>Credit Amount</span> <p class="make_bold">{{creditDetails[0].currency_symbol}}{{creditDetails[0].amount.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" >
                <span>Reason</span> <p class="make_bold" style="width: 250px;line-break: anywhere;display: flex;justify-content: flex-end;">{{creditDetails[0].purpose | titlecase}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" >
                <span>Approx Repayment Date</span> <p class="make_bold">{{creditDetails[0].aproxRepaymentDate | date}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" >
                <span>Creation Date</span> <p class="make_bold">{{creditDetails[0].creationDate | date}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" >
                <span>Notes</span> <p class="make_bold" style="width: 250px;line-break: anywhere;display: flex;justify-content: flex-end;">{{creditDetails[0].repaymentNotes | titlecase}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" >
                <span>Credit Type</span> <p class="make_bold">{{creditDetails[0].payment_mode1 | titlecase}}</p>
            </div>
            <div class="item_list_data add_margin_bottom" >
                <span>Status</span> <p class="make_bold">{{creditDetails[0].status1 | titlecase}}</p>
            </div>
           
        </div>
    <div *ngIf="creditDetails[0].transtionsInfo">
        <div class="item_list add_padding" *ngFor="let item of creditDetails[0].transtionsInfo" style="border: 5px solid lightgray;">
            <div class="item_list_data add_margin_bottom">
                <span>Return Amount</span> <p class="make_bold">{{creditDetails[0].currency_symbol}}{{item.amount.toFixed(2)}}</p>
            </div>
            <div class="item_list_data add_margin_bottom">
                <span>Pay Date</span> <p class="make_bold">{{item.date | date}}</p>
            </div>
            <div class="item_list_data add_margin_bottom">
                <span>Return Type</span> <p class="make_bold">{{creditDetails[0].payment_mode1 | titlecase}}</p>
            </div>
        </div>
    </div>
      
    
       
    </div>
    </mat-dialog-content>
